import { render } from "./hotel-input.vue?vue&type=template&id=2f5fc37e"
import script from "./hotel-input.vue?vue&type=script&lang=js"
export * from "./hotel-input.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__